import React, { Component } from 'react';
import image from '../../assets/img/vector/enlace.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/enlace.jpg';
import img1 from '../../assets/img/flat/enlace1.svg';
import img2 from '../../assets/img/flat/enlace2.svg';
import img3 from '../../assets/img/flat/enlace3.svg';
import IconBlock from '../../subcomponents/IconBlock28';

class EnlaceDatos extends Component {

  componentDidMount() {
    document.title = 'Enlace de Datos - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Calidad de servicio',
        description: 'Posibilidad de asegurar recursos para servicios críticos',
        img: img1
      },
      { id: 2, title: 'Velocidad', description: 'Desde 1 Mbps hasta 1 Gbps', img: img2 },
      { id: 3, title: 'Ajustado a sus Necesidades', description: 'Enlaces en L2 o L3', img: img3 }
    ];

    const descripcion =
      'Soluciones de conectividad que permitirán que su red empresarial distribuida funcione como una sola, facilitando la colaboración desde cualquier ubicación.';

    return (
      <Section asuntoContacto={'Enlace de Datos'}>
        <SectionContainer grey paddingTop={70} paddingBottom={40}>
          <ImageText image={image} title="Enlace de Datos" description={descripcion}></ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={imgBody1}
            title="Características"
            description="Aproveche las posibilidades que permite tener una red empresarial distribuida para
              acceder a recursos y dispositivos compartidos, independiente si lo hace desde la casa
              matriz o desde una sucursal.">
            <ul className="list-unstyled mb-0 mt-4">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Interconexión mediante enlaces de Cobre y Fibra Óptica.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Operación con mantención 24x7.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Monitoreo de la red 24x7.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Posibilidad de entregar acceso redundante N+1.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default EnlaceDatos;



// WEBPACK FOOTER //
// ./src/sections/telecomunicaciones/EnlaceDatos.js